import { Toolbar , Item} from "devextreme-react/data-grid";

export const getDataGridCustomToolbar = (title) => (
    <Toolbar>
        <Item location="before">
            <div className="informer">
                <span className="count">
                    {title}
                </span>
            </div>

        </Item>
        <Item name="addRowButton" location="after" />
    </Toolbar>
)


export const getDataGridCustomToolbarCaption = (title) => (
    <Item location="before">
        <div className="informer">
            <span className="count">
                {title}
            </span>
        </div>
    </Item>
)
